import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/tema3/tooltipsKoxka.glb"
import { GUI } from "dat.gui";
import gsap from "gsap";

export class TooltipsKoxka extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		// this.rotation.y = MathUtils.degToRad(90)
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);

			this.pizzas = gltf.scene.getObjectByName("pizzas", true);
			this.ensambles = gltf.scene.getObjectByName("ensambles", true);
			this.postres = gltf.scene.getObjectByName("postres", true);
		});
	}

	clearAnimation() {
		if (this.animation) {
			this.animation.kill();
			this.animation = null;
			this.pizzas.material.opacity = 1
			this.ensambles.material.opacity = 1
			this.postres.material.opacity = 1
		}
	}

	onAnimateOpacity() {

		this.clearAnimation()

		// Creamos un objeto con la propiedad de opacidad para poder animarla
		const opacityObject = { opacity: 1 };

		// Animación de opacidad de 0.6 a 0.4 y viceversa en bucle
		this.animation = gsap.to(opacityObject, {
			opacity: 0.7,
			yoyo: true,
			repeat: -1,
			duration: 1,
			ease: 'power1.inOut',
			onUpdate: () => {
				// Actualizamos la opacidad del material en cada fotograma
				this.pizzas.material.opacity = opacityObject.opacity;
				this.ensambles.material.opacity = opacityObject.opacity;
				this.postres.material.opacity = opacityObject.opacity;
			},
		});

	}

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("Tooltips koxka");
		premiaFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		premiaFolder.add(this.scale, "x", -5, 5).step(0.0001).name("scale X");
		premiaFolder.add(this.scale, "y", -5, 5).step(0.0001).name("scale Y");
		premiaFolder.add(this.scale, "z", -5, 5).step(0.0001).name("scale Z");
		premiaFolder.add(this, "visible").name("Visible");
	}

	helpersChild() {
		this.helperMethod("pizzas", this.pizzas);
		this.helperMethod("ensambles", this.ensambles);
		this.helperMethod("postres", this.postres);
	}

	helperMethod(name, object, limitPosicion = 20, limitRotation = 5) {
		const { position, rotation } = object;
		const gui = new GUI();
		const folferMostrador = gui.addFolder(name);
		folferMostrador.add(position, "x", -limitPosicion, limitPosicion).step(0.0001).name("Posición X");
		folferMostrador.add(position, "y", -limitPosicion, limitPosicion).step(0.0001).name("Posición Y");
		folferMostrador.add(position, "z", -limitPosicion, limitPosicion).step(0.0001).name("Posición Z");
		folferMostrador.add(rotation, "x", -limitRotation, limitRotation).step(0.0001).name("rotation X");
		folferMostrador.add(rotation, "y", -limitRotation, limitRotation).step(0.0001).name("rotation Y");
		folferMostrador.add(rotation, "z", -limitRotation, limitRotation).step(0.0001).name("rotation Z");
		folferMostrador.add(object, "visible").name("Visible");
	}

	renderAnimations() { }
}
